import { isEmpty, map } from "lodash";
import React from "react";
import RichText from "../rich-text";

import * as styles from "./index.module.scss";

export default function({ menuNotices }) {
  if (isEmpty(menuNotices)) {
    return null;
  }

  return (
    <small>
      {map(menuNotices, ({ message }, index) => (
        <ul key={index}>
          <li className={styles.MenuNotice}>
            <RichText>{message}</RichText>
          </li>
        </ul>
      ))}
    </small>
  );
}
